export default "__VITE_ASSET__DOs4wpJs__"